import DisplayReturnDetails from '../DisplayReturnDetail'
import DisplayRMAReturnDetails from '../DisplayRMAReturnDetails'
import DoneReturn from '../DoneReturn'
import RMADetailLoader from '../RMADetailLoader'

const useManageRMADetailComponent = ({
  moduleData,
}) => {
  const {
    data,
    displayReturnDetails,
    doneReturn,
  } = { ...moduleData }
  if (!data) return RMADetailLoader
  if (displayReturnDetails) return DisplayReturnDetails
  if (doneReturn) return DoneReturn
  return DisplayRMAReturnDetails
}

export default useManageRMADetailComponent
